import { IPoint } from "../../helpers/Geometry";
import { IViewHost } from "../abstraction/IViewHost";
import { IViewTool, IViewToolOptions } from "../abstraction/IViewTool";

export abstract class BaseViewTool<TOptions extends IViewToolOptions = IViewToolOptions> implements IViewTool<TOptions> {

    protected _host: IViewHost;
    protected _isActive: boolean;
    protected _isStarted: boolean;

    attach(mapView: IViewHost) {

        this._host = mapView;

        if (this.isActive)
            this.activate();
    }

    activate() {
        this._isActive = true;
    }

    deactivate() {
        this._isActive = false;
    }

    end() {
        this._isStarted = false;
    }

    configure(options: TOptions) {

        if (options?.isActive !== undefined)
            this._isActive = options.isActive;
    }

    protected getViewPointEvent(ev: PointerEvent | MouseEvent | Touch) {

        return this.getViewPoint({ x: ev.clientX, y: ev.clientY });
    }

    protected getViewPoint(point: IPoint) {

        const clientRect = this._host.container.getBoundingClientRect();

        return {
            x: (point.x - clientRect.x) * window.devicePixelRatio,
            y: (point.y - clientRect.y) * window.devicePixelRatio,
        }
    }

    get isStarted() {
        return this._isStarted;
    }

    get isActive() {
        return this._isActive;
    }

    abstract readonly name: string;
}